import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";
import { Phone, Email, AccessTime, LocalShipping, Info, ContactPhone } from "@mui/icons-material";
import logo from "../../assets/RCS.png";

const pages = [
  { id: "#service", name: "Services", target: "_self", icon: <LocalShipping /> },
  { id: "#about_us", name: "About Us", target: "_self", icon: <Info /> },
  {
    id: "https://web.whatsapp.com/send?phone=923016804252?&text=Thank you for contacting RCS XPRESS! Please let us know how we can help you.&app_absent=0",
    name: "Contact",
    target: "_blank",
    icon: <ContactPhone />
  },
];

function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      {/* Top Info Bar */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #025D9E 0%, #0277BD 100%)",
          color: "white",
          display: { xs: "none", md: "block" },
          borderBottom: "2px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 0",
              fontSize: "13px",
              fontFamily: "Montserrat",
            }}
          >
            <Box sx={{ display: "flex", gap: "30px", alignItems: "center" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Phone sx={{ fontSize: "16px" }} />
                <Link 
                  href="tel:+923016804252" 
                  sx={{ 
                    color: "white", 
                    textDecoration: "none",
                    fontWeight: 500,
                    "&:hover": { textDecoration: "underline" }
                  }}
                >
                  +92 301 6804252
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Email sx={{ fontSize: "16px" }} />
                <Link 
                  href="mailto:info@rcsxpress.com" 
                  sx={{ 
                    color: "white", 
                    textDecoration: "none",
                    fontWeight: 500,
                    "&:hover": { textDecoration: "underline" }
                  }}
                >
                  info@rcsxpress.com
                </Link>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <AccessTime sx={{ fontSize: "16px" }} />
              <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                24/7 Support Available
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Main Navigation */}
      <AppBar
        position="sticky"
        className="Navbar"
        sx={{
          background: scrolled 
            ? "rgba(255, 255, 255, 0.98)" 
            : "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(20px)",
          boxShadow: scrolled 
            ? "0 8px 40px rgba(0, 0, 0, 0.12)" 
            : "0 4px 30px rgba(0, 0, 0, 0.08)",
          borderBottom: "1px solid rgba(2, 119, 189, 0.1)",
          transition: "all 0.3s ease",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar 
          disableGutters 
          sx={{ 
            padding: scrolled ? "6px 0" : "12px 0", 
            transition: "padding 0.3s ease",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          {/* Mobile Menu Button */}
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              alignItems: "center",
            }}
          >
            <IconButton
              size="small"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              sx={{
                color: "#1a1a2e",
                background: "rgba(2, 119, 189, 0.1)",
                borderRadius: "8px",
                padding: "8px",
                "&:hover": {
                  background: "rgba(2, 119, 189, 0.2)",
                  transform: "scale(1.05)",
                }
              }}
            >
              <MenuIcon sx={{ fontSize: "28px" }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
                "& .MuiPaper-root": {
                  background: "rgba(255, 255, 255, 0.98)",
                  backdropFilter: "blur(20px)",
                  borderRadius: "8px",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
                  marginTop: "8px",
                }
              }}
            >
              {pages.map((page, index) => (
                <MenuItem 
                  key={index} 
                  onClick={handleCloseNavMenu}
                  sx={{
                    padding: "12px 20px",
                    margin: "4px 8px",
                    borderRadius: "8px",
                    "&:hover": {
                      background: "linear-gradient(135deg, rgba(3, 169, 244, 0.1) 0%, rgba(2, 119, 189, 0.1) 100%)",
                    }
                  }}
                >
                  <a
                    href={page.id}
                    target={page.target}
                    style={{ 
                      textDecoration: "none", 
                      color: "#1a1a2e",
                      fontWeight: 600,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px"
                    }}
                  >
                    {page.icon}
                    <Typography>{page.name}</Typography>
                  </a>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Logo */}
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center",
            }}
          >
            <Link href="#" underline="none">
              <img
                src={logo}
                alt="RCS Express"
                style={{ 
                  objectFit: "contain",
                  filter: "drop-shadow(2px 2px 6px rgba(2, 119, 189, 0.2))",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  width: scrolled ? "130px" : "150px",
                  height: "auto"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.filter = "drop-shadow(2px 4px 10px rgba(2, 119, 189, 0.4))";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.filter = "drop-shadow(2px 2px 6px rgba(2, 119, 189, 0.2))";
                }}
              />
            </Link>
          </Box>

          {/* Desktop Navigation & CTA */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexGrow: 1, justifyContent: "flex-end" }}>
            {/* Desktop Menu Links */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: "8px"
              }}
            >
              {pages.map((page, index) => (
                <a
                  key={index}
                  href={page.id}
                  target={page.target}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="text"
                    onClick={handleCloseNavMenu}
                    startIcon={page.icon}
                    sx={{
                      color: "#1a1a2e",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontFamily: "Montserrat",
                      fontWeight: "600",
                      fontSize: "15px",
                      padding: "12px 22px",
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      position: "relative",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        bottom: "6px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "0%",
                        height: "3px",
                        background: "linear-gradient(90deg, #03A9F4, #0277BD)",
                        borderRadius: "2px",
                        transition: "width 0.3s ease",
                      },
                      ":hover": {
                        color: "#0277BD",
                        background: "linear-gradient(135deg, rgba(3, 169, 244, 0.08) 0%, rgba(2, 119, 189, 0.08) 100%)",
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(2, 119, 189, 0.15)",
                        "&::after": {
                          width: "70%",
                        }
                      },
                    }}
                  >
                    {page.name}
                  </Button>
                </a>
              ))}
            </Box>

            {/* CTA Button - Always on the right */}
            <Link href="tel:+923016804252" underline="none" color="inherit">
              <Button
                variant="contained"
                size="medium"
                className="modern-button"
                startIcon={<Phone />}
                sx={{
                  background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
                  border: "none",
                  borderRadius: "8px",
                  padding: { xs: "8px 14px", sm: "12px 28px" },
                  fontFamily: "Montserrat",
                  fontWeight: 700,
                  fontSize: { xs: "11px", sm: "14px" },
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                  boxShadow: "0px 12px 40px -10px rgba(2, 119, 189, 0.6)",
                  color: "white",
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: "0",
                    height: "0",
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.3)",
                    transform: "translate(-50%, -50%)",
                    transition: "width 0.6s, height 0.6s",
                  },
                  ":hover": {
                    background: "linear-gradient(135deg, #0277BD 0%, #025D9E 100%)",
                    transform: "translateY(-3px) scale(1.02)",
                    boxShadow: "0px 20px 60px -8px rgba(2, 93, 158, 0.8)",
                    "&::before": {
                      width: "300px",
                      height: "300px",
                    }
                  },
                  ":active": {
                    transform: "translateY(-1px) scale(1)",
                  }
                }}
              >
                Get Free Quote
              </Button>
            </Link>
          </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
}
export default Navbar;
